import { Box, Table, TableBody, TableContainer } from "@mui/material";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { EmploymentsHierarchy } from "../../../talents/talentAPI";
import { AccessRightContext } from "../../../user/AccessRightProvider";
import BundleHeader from "../Shared/BundleHeader/BundleHeader";
import EmploymentRow from "../Shared/EmploymentRow";
import { EmploymentRowType } from "../types";

interface Props {
  employmentsHierarchy: EmploymentsHierarchy[];
  translatedTESNames: { [key: string]: string };
  type: EmploymentRowType;
}

const Upcoming = ({
  employmentsHierarchy,
  translatedTESNames,
  type,
}: Props) => {
  const [open, setOpen] = useState<boolean>(true);
  const { t } = useTranslation();

  const { canReadEmployment } = useContext(AccessRightContext);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        background: "#FFFFFF",
        alignItem: "center",
      }}
    >
      <BundleHeader
        open={open}
        setOpen={setOpen}
        title={t("talentProfile:upcomingEmployments")}
      />
      {open && (
        <TableContainer>
          <Table>
            <TableBody>
              {employmentsHierarchy.map((employmentBundle, index) =>
                employmentBundle.employments.map((employment, innerIndex) => (
                  <EmploymentRow
                    disabled={!canReadEmployment(employmentBundle.employerId)}
                    key={`upcomingEmpRow${index}-${employment.employmentId}-${innerIndex}`}
                    index={innerIndex}
                    type={type}
                    employment={employment}
                    tesName={translatedTESNames[employmentBundle.tesId]}
                    employerName={employmentBundle.employerName}
                    isShift={employmentBundle.isShift}
                    continuousEmploymentId={
                      employmentBundle.continuousEmploymentId
                    }
                  />
                )),
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default Upcoming;
